import { useEffect } from "react";

import { EntityType } from "@mapmycustomers/shared";
import { EntityTypesSupportingSavedFilters } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import SavedFilter from "@mapmycustomers/shared/types/viewModel/SavedFilter";

import useView from "@app/component/view/utils/useView";

import { applySavedFilter } from "./applySavedFilter";

// Apply rules from saved filter when it is changed
export const useSavedFilterApplicator = <T extends SavedFilter>(
  entityType: EntityTypesSupportingSavedFilters,
  selectedFilter: T | undefined,
  implicitFilterFields: IField[] | undefined,
  processSavedFilter?: (savedFilter: T) => T | undefined
) => {
  const { fieldModel, updateFilterModel } = useView();

  useEffect(() => {
    applySavedFilter(
      selectedFilter,
      entityType,
      processSavedFilter,
      implicitFilterFields,
      updateFilterModel,
      entityType === EntityType.ACTIVITY ? entityType : undefined
    );
  }, [
    entityType,
    fieldModel,
    implicitFilterFields,
    processSavedFilter,
    updateFilterModel,
    selectedFilter,
  ]);
};
